import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
  contract: IContract;
}

export enum EField {
  Info = "_info",
  ContractRentPrice = "contractRentPrice",
  BuildingSurfaceArea = "buildingSurfaceArea",
  // BuildingFloor = "buildingFloor",
  BuildingLayers = "buildingLayers",
  BuildingAdjoined = "buildingAdjoined",
  BuildingHasHardMaterials = "buildingHasHardMaterials",
}
